import angular from 'angular';
import { MeurhAdmissoesDadospessoaisFormController } from './dadospessoais.form.controller';

export class MeurhAdmissoesDadospessoaisFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesDadospessoaisFormComponent';
	static controller = MeurhAdmissoesDadospessoaisFormController;
	static template = require('!!html-loader!./dadospessoais.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
